import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { Component, Fragment } from "react";

const styles = (theme) => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  spacer: {
    marginTop: "15px",
    marginBottom: "15px",
  },

  bold: {
    fontWeight: "700",
  },
  subIndentation1: {
    marginLeft: "-20px",
    listStyleType: "lower-alpha",
  },
  textSpacer: {
    "& p": {
      marginTop: "8px",
      marginBottom: "8px",
    },
  },
  buttonStyling: {
    textTransform: "inherit",
    fontWeight: "unset",
    padding: "0",
    lineHeight: "unset",
    textDecoration: "underline",
    display: "contents",
  },
});

export default withStyles(styles)(
  class HomeLoansTerms extends Component {
    state = {
      open: false,
    };

    handleClickOpen = () => {
      this.setState({ open: true });
    };

    handleClose = () => {
      this.setState({ open: false });
    };

    render() {
      const { classes } = this.props;

      return (
        <Fragment>
          <div className={classes.textSpacer}>
            <Typography variant="body1" gutterBottom>
              I/We confirm that the information given by me is true and correct.
              I hereby authorize EastWest to verify such information and
              investigate from whatever sources it may consider appropriate. I
              understand that EastWest reserves the right not to approve my
              application for certain conditions that are contrary to the Bank's
              policy.
            </Typography>
            <Typography variant="body1" gutterBottom>
              I understand that the initial credit rating of "Passed" does not
              constitute outright approval of my application. All documents,
              credit and collateral, submitted by me shall be subject to
              verification (including title verification, Bank checkings, etc.)
              and proper evaluation based on the existing procedures and
              policies of the Bank.
            </Typography>
            <Typography variant="body1" gutterBottom>
              I signify my agreement to the Terms and Conditions governing my
              on-line housing loan application with EastWest.
            </Typography>

            <Button
              color="secondary"
              className={classes.buttonStyling}
              onClick={this.handleClickOpen}
            >
              Read full Terms and Conditions here.
            </Button>
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">
                Terms and Conditions Governing EastWest Home Loan Accounts
              </DialogTitle>
              <DialogContent>
                <Typography variant="body1" gutterBottom>
                  By signing with us, the Applicant agrees to abide by the Terms
                  and Conditions Governing EastWest Home Loan Accounts. The
                  Applicant also agrees to be bound by any and all amendments
                  thereto as well as all laws, rules, regulations and official
                  issuances applicable to EastWest which may hereinafter be
                  issued, as well as such other terms and conditions governing
                  the use of other facilities, benefits, products or services
                  which shall be made available to me/us. The Applicant also
                  agrees that EastWest may change any of the provisions in its
                  Terms and Conditions and the fees and charges for its products
                  and/or services from time to time and the Applicant agrees to
                  be notified of such changes through notice sent through any of
                  the following means, at the discretion of EastWest unless the
                  Applicant requests otherwise: (i) mailed and/or emailed
                  notices (sent to the Applicant's mailing or email addresses
                  indicated in EastWest's records), (ii) notices posted at
                  EastWest's branches or (iii) notices in its website.
                </Typography>
                <Typography variant="body1" gutterBottom>
                  The Applicant also agrees that the Applicant's Application
                  Form shall also serve as the Applicant's application for other
                  products of EastWest, such as, but not limited to, Credit
                  Card, Personal Loan, Emerging Enterprise Lending, among
                  others, if the Applicant is deemed qualified by EastWest. The
                  Applicant undertakes to submit additional documents as may be
                  required by EastWest for the processing of the Applicant's
                  application. The Applicant understands that the Applicant's
                  application for the other products of EastWest shall be
                  subject to credit evaluation and the approval shall be subject
                  to the discretion of EastWest. The Applicant understands that
                  EastWest can rely on the authority/ies given under herein
                  unless the Applicant explicitly revokes the same.
                </Typography>
                <Typography variant="body1" gutterBottom>
                  The Applicant hereby certifies that all information stated in
                  the application Application Form and the documents submitted
                  for this application are complete, true and correct.
                </Typography>
                <Typography variant="h6" color="secondary" gutterBottom>
                  Disclosure and Sharing of Information
                </Typography>
                <ol className={classes.subIndentation1}>
                  <li>
                    <Typography variant="body1" className={classes.bold}>
                      Processing of application
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      The Applicant hereby authorizes EastWest to conduct random
                      verification with the BIR, any other appropriate
                      government agencies or third parties including banks and
                      financial institutions to establish the authenticity of
                      the information the Applicant declared and the documents
                      the Applicant submitted (e.g. bank statements, certificate
                      of employment, payslips and income tax return) in relation
                      to the Applicant's application as it may be necessary for
                      the processing and evaluating of the Applicant's
                      application and the Applicant further hereby waives all
                      confidentiality rules and laws, such as Republic Act No.
                      1405, as amended, Republic Act. No. 6426, as amended,
                      Section 55.1 of Republic Act No. 8791, Data Privacy Act of
                      2012 and other applicable laws or regulations.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" className={classes.bold}>
                      Account Maintenance and Servicing
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      The Applicant hereby authorizes the transfer, disclosure
                      and communication of EastWest of any information relating
                      to the Applicant's accounts with EastWest together with
                      all of the documents submitted for this application to any
                      of its offices, branches, subsidiaries, affiliates, agents
                      and representatives of EastWest and third parties for
                      confidential use in connection with EastWest's exercise of
                      its functions or for any business purposes (including but
                      not limited to sales and marketing, credit investigation
                      and collection, information technology systems and
                      processes, data processing, imaging and storage, back-up
                      and recovery and risk analyses purposes). The Applicant
                      hereby also authorizes the regular submission and
                      disclosure to any and all credit information service
                      providers such as, but not limited to, Credit Card
                      Association of the Philippines, Credit Information
                      Corporation, Bangko Sentral ng Pilipinas, Anti Money
                      Laundering Council, Banker's Association of the
                      Philippines, of any information, whether positive or
                      negative relating to the Applicant's basic credit data (as
                      defined under R.A. No 9510) with EastWest as well as any
                      updates or corrections thereof. The foregoing constitutes
                      the Applicant's written consent for any such submission
                      and disclosure of information relating to the Applicant's
                      accounts for the purpose indicated above and under
                      applicable laws, rules and regulations.{" "}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      The Applicant agrees to release, indemnify and hold
                      harmless, EastWest Bank from any liabilities that may
                      arise from any transfer, disclosure or storage of
                      information relating to the Applicant's accounts.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" className={classes.bold}>
                      Marketing and Sales Offers
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      The Applicant hereby authorizes the transfer, disclosure
                      and communication of EastWest of any information relating
                      to the Applicant's accounts with EastWest together with
                      all of the documents submitted for this application to any
                      of its offices, branches, subsidiaries, affiliates, agents
                      and representatives of EastWest and third parties for
                      product and service offers to be made to the Applicant
                      through mail/e-mail/fax/SMS or telephone, and for any
                      other purpose as EastWest may deem appropriate, unless I
                      expressly notify EastWest otherwise through the following
                      contact information :
                    </Typography>
                    <table border="1" class="jsontable">
                      <tr>
                        <td>
                          <strong>Customer Service Hotline</strong>
                        </td>
                        <td>
                          <a href="tel:+0288881700" className="content-link">
                            (632) 8888-1700
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Email</strong>
                        </td>
                        <td>
                          <a
                            href="mailto:csloans@eastwestbanker.com"
                            className="content-link"
                          >
                            csloans@eastwestbanker.com
                          </a>
                        </td>
                      </tr>
                    </table>
                  </li>
                </ol>
                <Typography variant="body1" gutterBottom>
                  The Applicant understands that the Applicant's application is
                  subject to EastWest Bank's credit policies and procedures. In
                  case of disapproval of the Applicant's application, the
                  Applicant understands that EastWest is under no obligation to
                  disclose the reason/s for such disapproval unless required by
                  law or regulation. The accomplished application form and
                  requirement/s the Applicant submitted becomes the property of
                  EastWest and EastWest is under no obligation to return the
                  said documents to the Applicant regardless of the outcome of
                  the application.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="secondary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Fragment>
      );
    }
  }
);
